import lodashGet from 'lodash.get';

import { IRoute, ITransport } from '@typing/Trip';

// Транспорт привязан к точке маршрута заявки через ParentTripRouteId - оно проставляется
// атомарно при создании ТС и всегда актуально. UUID справочного маршрута резолвим по факту,
// хранить его в самом ТС нельзя: значение устаревает при смене маршрута/территории/парка.
//
// ВАЖНО: и сборка заявки (OrderDataStore.postOrder), и экран оплаты обязаны отбирать ТС
// по этому резолверу. Если предикаты разъедутся, экран оплаты покажет пользователю ТС,
// которое не уйдет на бэк - он заплатит, а в разрешении транспорта не будет.
export const resolveTransportRouteUUID = (vehicle: ITransport, routes: IRoute[], territories: any[]): string | null => {
  const tripRoute = routes && routes.find((route: IRoute) => route && route.id === vehicle.ParentTripRouteId);

  if (!tripRoute) {
    return null;
  }

  return lodashGet(territories, [tripRoute.pointIndex as number, 'routes', tripRoute.routeIndex as number, 'id'], null);
};
